import { Theme } from '@mui/material';

const Dialog = (theme: Theme) => {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          width: '528px',
          [theme.breakpoints.down('tablet')]: {
            width: '100%',
          },
        },
      },
    },
  };
};

export default Dialog;
